// extracted by mini-css-extract-plugin
export default {"ebanner":"si-z"};